export default function doHipExceptionRedirect(loc: Location, hipPath: string) {
    loc.href = hipPath;
}
